export function millisecondsToMinutes(milliseconds: number): number {
  return Math.ceil((milliseconds * 0.001) / 60);
}
